import { appbarHeight, rvh, appbarHeightMobile } from "themes/constants/sizes"
import { masterBreakPoint } from "themes/default/breakpoints"

export const styles = {
  main: (theme) => ({
    position: "relative",
    width: "100vw",
    minHeight: `calc(${rvh()} - ${appbarHeight}px)`,
    top: appbarHeight,
    [masterBreakPoint]: {
      minHeight: `calc(${rvh()} - ${appbarHeightMobile}px)`,
    },
  }),
}
